import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { get as getCookie } from 'js-cookie';

export function localizeCSPForUser(user: Partial<IUser>) {
  return !!user?.countryCode && !['US', 'AU'].includes(user.countryCode);
}

export function localizeCSPItemRegion(itemRegionQueryParam, user: Partial<IUser>): string {
  if (itemRegionQueryParam) {
    return itemRegionQueryParam;
  }

  if (localizeCSPForUser(user)) {
    return user.countryCode;
  }

  return getCookie('itemRegionOverride');
}
